/* src/components/project-opportunities/project-opportunities.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=project-opportunities.component-ZUUNSQ7M.css.map */
